import React from 'react';
import { BadgeCheckIcon, FileCheck2Icon, GiftIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#09281d] px-5 py-20" data-id="element-76" data-mp="4xclkwxcokc2">
      <div className="mx-auto max-w-3xl border-t-8 border-emerald-400 bg-white p-8 text-center shadow-2xl sm:p-14" data-id="element-77" data-mp="9u37i0vu6a5e">
        <p className="inline-flex items-center gap-2 bg-emerald-500 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-78" data-mp="eu8uh3r5v8h5">
          <BadgeCheckIcon className="h-4 w-4" data-id="element-79" data-mp="jqpt4rvzl58h" /> Cero riesgo · 100% protegido
        </p>
        <ShieldCheckIcon className="mx-auto mt-7 h-20 w-20 text-emerald-700" strokeWidth={1.4} data-id="element-80" data-mp="ns1bqdgg0q76" />
        <h2 className="mt-6 font-display text-5xl font-bold uppercase leading-none text-[#09281d] sm:text-6xl" data-id="element-81" data-mp="xjxj6f4f5so2">
          Garantía de <span className="text-emerald-700" data-id="element-82" data-mp="12jtg5uep8ju4">7 días</span>
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-lg font-medium text-slate-600" data-id="element-83" data-mp="17i4r68gqd0dx">
          Revisa el contenido. Úsalo. Pruébalo en tus clases.
        </p>
        <p className="mt-5 text-2xl font-bold leading-tight text-[#09281d]" data-id="element-84" data-mp="25ti5kiflimzh">
          Si Educación Física Lista™ no transforma tu forma de enseñar,{' '}
          <span className="text-emerald-700" data-id="element-85" data-mp="1vthkos22vyt6">
            te devolvemos tu dinero. Sin preguntas.
          </span>
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3 text-xs font-bold text-[#09281d]" data-id="element-86" data-mp="1rt7bl6izosa3">
          <span className="flex items-center gap-1.5" data-id="element-87" data-mp="2oh3mpvvnqvdx">
            <ZapIcon className="h-4 w-4 text-emerald-700" data-id="element-88" data-mp="2jjlmctvphohj" /> Devolución simple
          </span>
          <span className="flex items-center gap-1.5" data-id="element-89" data-mp="2esll5cfk0k98">
            <FileCheck2Icon className="h-4 w-4 text-emerald-700" data-id="element-90" data-mp="2er28dvt3wrc7" /> Sin
            formularios
          </span>
          <span className="flex items-center gap-1.5" data-id="element-91" data-mp="2aqrtftnc6ql7">
            <GiftIcon className="h-4 w-4 text-emerald-700" data-id="element-92" data-mp="37963r8c7odop" /> Conservas los
            bonos
          </span>
        </div>
      </div>
    </section>;
}